import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"download\">\n    <path fill-rule=\"evenodd\" d=\"M20.51 22.23H4.523c-.276 0-.293-.431-.293-.707 0-.277.017-.293.293-.293H20.51c.277 0 .59.016.59.293 0 .276-.313.707-.59.707zm-7.948-4.331L8.87 14.9l3.29-.4V2.999c0-.276.079-.5.356-.5.276 0 .644.224.644.5V14.4l3.34-.401-3.938 3.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol